import React from 'react';
import PropTypes from 'prop-types';
import {Suspense} from 'react';
import {Notebook} from '../Notebook';
import {LevelSelector} from '@learningblocks/storybook-components';
import {Modal, Log} from '@learningblocks/shared-components';
import {ProtocolView} from '../ProtocolView';
import {Modal as SceneModal} from "../ProtocolScene/Dialogs/modal";

import {PageTour} from './PageTour';
import {
  TOUR_PROPERTIES
} from '@learningblocks/protocol-constants/lib/Utilities';

const simulationLevels = [
  {
    id: 1,
    label: 'Level one',
    description: 'For those unfamiliar with the technique, offers the most support and hints.',
    value: 'levelOne'
  },
  // {
  //   id: 2,
  //   label: 'Level two',
  //   description: 'For users familiar with the technique, offers fewer procedural hints and less detailed explanations of the procedural steps.',
  //   value: 'levelTwo'
  // },
  // {
  //   id: 3,
  //   label: 'Level three',
  //   description: 'For ​those well acquainted with the technique, emphasizing ​exploration of ​new skills and topics.',
  //   value: 'levelThree'
  // }
];

import BackgroundImage from "./img/Background.svg"

export class MainScene extends React.Component {
  componentDidMount(){}
  componentWillMount(){
    if(simulationLevels.length === 1){
      this.props.setLevel(simulationLevels[0]);
      this.props.setNoteBookSection('CONTEXT');
    }
  }

  render() {
    return (
      <div style={{
        backgroundImage: `url(${BackgroundImage})`,
        width: "100vw",
        height: "100vh"
      }}>
        {(simulationLevels.length > 1)?(
          <Modal
            isOpen={this.props.showLevelModal}
            contentLabel='Select Simulation Level'
            className='Modal sm'
            size='sm'
            parentElement={'container'}>
            <Suspense fallback="...">
              <LevelSelector
                simulationLevels={simulationLevels}
                defaultSelected={1}
                setLevel={(level)=>{
                  this.props.setLevel(level);
                  this.props.setNoteBookSection('CONTEXT');
                }}
              />
            </Suspense>
          </Modal>
        ):null}
        {!this.props.showLevelModal && (
          <>
            <Log
              level={this.props.levelSelected.id}
              section={this.props.currentSection.title.toLowerCase()}
            >
              <Notebook simulationLevels={simulationLevels} />
              <ProtocolView />
              <SceneModal />
            </Log>
          </>
        )}
      </div>
    );
  }
}

MainScene.propTypes = {
  showLevelModal: PropTypes.bool.isRequired,
  setLevel: PropTypes.func.isRequired,
  /**
   *  function for ending tour
   */
  endTour: PropTypes.func,
  /**
   *  function to  incrementing stepIndex
   */
  incrementTour: PropTypes.func,
  /**
   *  index for Page tour
   */
  stepIndex: PropTypes.number,
};
